<template>
  <div class="is-user-avatar">
    <img :src="photo">
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserAvatar',
  data() {
    return {
        photo: ''
    }
  },
  props: {
    avatar: {
      type: String,
      default: null
    }
  },
  mounted() {
       this.$root.$on('userProfileUpdated', (name, email, code_no, office_code_no, photoUrl) => {
         console.log('mountedsssss avatar');
          this.name = name;
          this.email = email;
          this.photo = photoUrl;
      })
  },
  created() {
this.photo =  this.$store.state.auth.user.photoUrl
  },
  computed: {
    // newUserAvatar () {
    //     return this.$store.state.auth.user.photoUrl
    //  },
  }
}
</script>
